const screenUtil = require('../utils/screen'),
	pubsub = require('../utils/pubsub'),
	DEFAULT_LAZYLOAD_THRESHOLD = 300;

let lazyLoadThreshold = DEFAULT_LAZYLOAD_THRESHOLD,
	waitingForInView = [];

function init(/** Settings */ settings) {
	lazyLoadThreshold = _isValidTreshold(settings.lazyLoadThreshold) ? settings.lazyLoadThreshold : DEFAULT_LAZYLOAD_THRESHOLD;
	waitingForInView = [];

	pubsub.subscribe('scroll', _resolveInViewSlots);
}

function waitForSlot(/** Slot */ slot) {
	return new Promise((resolve) => {
		if (_isInView(slot)) {
			resolve(slot);
		} else {
			waitingForInView.push({
				slot,
				resolve
			});
		}
	});
}

function _isInView(slot) {
	const threshold = _getThresholdForSlot(slot);

	return screenUtil.isInView(slot.node, threshold);
}

function _getThresholdForSlot(/** Slot */ slot) {
	return _isValidTreshold(slot.lazyLoadThreshold) ? slot.lazyLoadThreshold : lazyLoadThreshold;
}

function _isValidTreshold(threshold) {
	return typeof threshold === 'number' && !isNaN(threshold) && threshold >= 0;
}

function _resolveInViewSlots() {
	waitingForInView = waitingForInView.filter(({
		slot,
		resolve
	}) => {
		if (_isInView(slot)) {
			resolve(slot);

			return false;
		}

		return true;
	});
}

module.exports = {
	init,
	waitForSlot
};
